var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon ionic-ios-checkmark-circle",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M10 0a10 10 0 1010 10A10 10 0 0010 0zm5.12 7.236l-6.428 6.457a.868.868 0 01-.558.264.842.842 0 01-.563-.274L4.875 10.99a.192.192 0 010-.274l.856-.856a.186.186 0 01.269 0l2.135 2.135L14 6.086a.19.19 0 01.135-.061.175.175 0 01.135.058l.841.87a.19.19 0 01.014.283z",
    fill: "#126bd5"
  })));
};
export default SvgCheckmarkCircle;